import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function NavBar() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/')
        navigate(0)
    }

    const links = [
      { href: "/", label:"Home"},
      { href: "/schedule", label:"Schedule"},
      { href: "/services", label:"Services"},
      { href: "/contact", label:"Contact"},
    ]

    return (
      <>
      <nav className="text-white shadow:_0_5px_8px_rgba(0,0,0,0.3)] font-bold  absolute top-5 left--5 right-5 w-full z-50 bg-transparent">
      <div className="flex justify-end mx-auto py-4 pl-2 md:pr-4 md:pl-4">
      <div className="flex items-center space-x-5" id="navbar-default">
<ul className="flex items-center space-x-5">
  {links.map((link) => {
    const isActive = window.location.pathname === link.href;

    return (
      <li
        key={link.href}
        className={`hover:underline hover:decoration-[#E9A3FF] hover:decoration-3 hover:underline-offset-[8px]
          ${isActive ? "underline decoration-[#E9A3FF] decoration-3 underline-offset-[8px]" : ""}`}
      >
        <a href={link.href}>{link.label}</a>
      </li>
    );
  })}
</ul>
</div>
{/* <Link
    to="https://www.instagram.com/sina.in.flux/"
    className="block"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      className="w-8 h-8 rounded-full"
      src={require("./images/instagram_logo.png")}
      alt="Instagram Logo"
    />
  </Link> */}

      </div>
    </nav>
      </>
    );
};
